import { render, staticRenderFns } from "./VideoSort.vue?vue&type=template&id=ef88722c&scoped=true&"
import script from "./VideoSort.vue?vue&type=script&lang=js&"
export * from "./VideoSort.vue?vue&type=script&lang=js&"
import style0 from "./VideoSort.vue?vue&type=style&index=0&id=ef88722c&prod&lang=scss&"
import style1 from "./VideoSort.vue?vue&type=style&index=1&id=ef88722c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef88722c",
  null
  
)

export default component.exports